export const REPORT_COPY = {
  surveyClosed: 'This survey has closed',
  reportOverview: 'Report overview',

  previousTab: 'Previous tab',
  nextTab: 'Next tab',

  viewSurvey: 'View survey',
};
